import styled from "styled-components";

interface isActive {
    active?: boolean;
}

export const HeaderComponent = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 116px;
    z-index: 10;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: space-between;
    backdrop-filter: blur(6px);
    border-bottom-left-radius: 2rem;
    border-bottom-right-radius: 2rem;
    transition: transform 0.3s ease;
`;

export const HeaderContent = styled.div`
    display: flex;
    justify-content: space-between;
    margin-left: 5%;
    align-items: center;

    width: 100%;
`;

export const LogoDiv = styled.div``;

export const Logo = styled.img`
    display: flex;
    align-items: center;

    width: auto;
    height: 100px;
    @media only screen and (max-width: 1000px) {
        width: auto;
        height: 90px;
    }
`;

export const NavMenu = styled.div`
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    line-height: 1.5;
    font-family: 'Montserrat', sans-serif;
    margin: 0% 2% 0% -5%;
    color:  var(--orange);
    font-weight: 600;
    :hover {
        transition: color .2s ease-in-out;
    }
    span {
        font-size: 20px;
        transition: color .2s ease-in-out;
    }
`;

export const NavItem = styled.span<isActive>`
    cursor: pointer;
    padding: 0 5px;
    text-decoration: ${(props) => (props.active ? 'overline' : 'none')};
    text-decoration-thickness: 4px;
    text-underline-offset: 3px;
    /* text-decoration-color: #95246D; */
    color: ${(props) => (props.active ? 'var(--orange)' : 'inherit')};

    &:hover {
        color: #dc582a85;
    }
`;

export const MobileDiv = styled.div`
    margin: 0px 5px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100px;
`;

export const OrcamentoButton = styled.a`
  background: var(--orange);
  border-radius: 100px;
  color: #fff;
  padding: 0.5rem;
  text-align: center;
  justify-content: center;
  width: 200px;
  display: flex;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
`;